import { authAdmin } from "../../api";
import { getToken, getTokenRoles, removeToken } from "../storage/storage";
import { getAuthHeaders } from "../../config/api";

const authProvider = {
    login: async ({ username, password }) => {
        try {
            const data = await authAdmin({ username, password });
            return data;
        } catch (error) {
            throw new Error('Authentication error');
        }
    },
    logout: () => {
        removeToken();
        return Promise.resolve();
    },
    checkAuth: () => {
        return getToken() ? Promise.resolve() : Promise.reject();
    },
    checkError: (error) => {
        // Verificar si el error es de tipo 401 (Unauthorized)
        const status = error?.status || error?.response?.status;
        if (status === 401) {
            // Si hay un error de autenticación, elimina el token
            removeToken();
            return Promise.reject({ redirectTo: '/login', message: 'Su sesión ha caducado, por favor inicie sesión nuevamente' });
        }
        // Si no es un error de autenticación, resuelve la promesa
        return Promise.resolve();
    },
    // Los roles vienen del propio JWT. Se usan solo para decidir qué se pinta; quién puede hacer
    // qué lo decide el backend.
    getPermissions: () => Promise.resolve(getTokenRoles()),
    getHeaders: () => getAuthHeaders(),
};

export default authProvider;
